import React from 'react';
import cls from 'classnames';
import parse from 'html-react-parser';
import makeBodyText from '../../utils/makeText';
import makeIconName from '../../utils/makeIconName';
import Links from './Links';
import ReferFriend from './ReferFriend';
import { ICONS } from '../../constants/icons';
import { DEFAULTS } from './constants';
import styles from './index.module.scss';
const Footer = ({ withReferFriend, dataToAppear, disabledDisclosure, ncMarketing, parseText }) => {
    const { title, mainText, contact, creds, links, social, disclosure } = dataToAppear || {};
    const renderText = (text) => {
        if (parseText) {
            return parse(text);
        }
        return text;
    };
    const divider = ({ index, length, dividerStr, lastDividerStr }) => {
        if (index + 1 >= length) {
            return '';
        }
        return index + 2 === length ? lastDividerStr : dividerStr;
    };
    const _renderTalkToUs = (ttuData) => {
        const { title: ttuTitle, text, number } = ttuData;
        let { links: ttuLinks } = ttuData;
        if (!('links' in ttuData)) {
            // backward compatibility
            ttuLinks = [
                {
                    type: 'tel',
                    text: text || DEFAULTS.contact.talkToUs.links[0].text,
                    href: number || DEFAULTS.contact.talkToUs.links[0].href
                }
            ];
        }
        return (React.createElement("div", { className: `${styles.talkToUs} talkFooter` },
            React.createElement("span", { className: `${makeBodyText('XL')} ${styles.title}` }, ttuTitle || DEFAULTS.contact.talkToUs.title),
            ttuLinks.map((link, index, array) => {
                return (
                // eslint-disable-next-line react/no-array-index-key
                React.createElement(React.Fragment, { key: `ttu_link_${index}` },
                    React.createElement("a", { id: `talk_to_use_link__footer_${index}`, href: `${link.type}:${link.href}`, className: `${makeBodyText('L')} ${styles.text}` }, link.text),
                    divider({ index, length: array.length, dividerStr: ', ', lastDividerStr: ' or ' })));
            })));
    };
    const _renderSocial = (socialData) => socialData.map((link) => {
        return (React.createElement("a", { title: link.alt, key: link.icon, className: styles.link, href: link.href, target: link.target },
            React.createElement("i", { className: `${makeIconName(ICONS.x38[link.icon], 'x38')} ${styles.icon}` })));
    });
    const _renderMainText = (text) => {
        const _content = (item) => React.createElement("div", { className: `${makeBodyText('L')} ${styles.text}` }, renderText(item));
        if (text === null || text === void 0 ? void 0 : text.map) {
            return text.map((textItem, i) => {
                return (React.createElement(React.Fragment, { key: i },
                    _content(textItem),
                    React.createElement("br", null)));
            });
        }
        return _content(text);
    };
    const _renderDisclosure = (disclosureData) => disclosureData.map((paragraph, i) => {
        return (React.createElement(React.Fragment, { key: i },
            React.createElement("div", { className: `${styles.text} ${makeBodyText('S')}` }, renderText(paragraph)),
            React.createElement("br", null)));
    });
    return (React.createElement("footer", { className: cls(styles.footerWrapper, {
            [styles.ncMarketing]: ncMarketing
        }) },
        React.createElement("div", { className: styles.footerContainer, id: 'footer-footerContainer' },
            React.createElement("span", { className: `${makeBodyText('XL')} ${styles.title}` }, title || DEFAULTS.title),
            _renderMainText(mainText || DEFAULTS.mainText),
            React.createElement("div", { className: styles.contacts, id: 'footer-contacts' },
                _renderTalkToUs((contact === null || contact === void 0 ? void 0 : contact.talkToUs) || DEFAULTS.contact.talkToUs),
                React.createElement(ReferFriend, { withReferFriend: withReferFriend, contact: contact })),
            React.createElement("div", { className: styles.creds, id: 'footer-creds' },
                React.createElement("span", { className: `${makeBodyText('L')} ${styles.title}` }, creds || DEFAULTS.creds)),
            React.createElement("hr", { className: styles.delimiter }),
            React.createElement("div", { className: `${styles.links} ${ncMarketing ? 'row' : ''}`, id: 'footer-links' },
                React.createElement(Links, { links: links || DEFAULTS.links, ncMarketing: ncMarketing })),
            React.createElement("hr", { className: styles.delimiter }),
            React.createElement("div", { id: 'footer-socialContainer', className: styles.socialContainer },
                React.createElement("div", { className: styles.social }, _renderSocial(social || DEFAULTS.social))),
            !disabledDisclosure && (React.createElement("div", { id: 'footer-disclosure', className: styles.disclosure }, _renderDisclosure(disclosure || DEFAULTS.disclosure))))));
};
export default Footer;
